module.exports = __webpack_public_path__ + "static/media/4.dc82888b.jpg";